module.exports = __webpack_public_path__ + "static/media/move.c08f61db.svg";